console.log("onpage");

function openBox(popContent) {
  var popBox = document.getElementById(popContent); //popContent = popBox;
  var popLayer = document.getElementById("popLayer");
  popBox.style.display = "block";
  popLayer.style.display = "block";

  if (window.innerWidth <= 767) {
    document.querySelector("body").classList.add("no-scroll");
  }
}

function closeBox(popContent) {
  var popBox = document.getElementById(popContent); //popContent = popBox;
  var popLayer = document.getElementById("popLayer");
  popBox.style.display = "none";
  popLayer.style.display = "none";
  if (window.innerWidth <= 767) {
    document.querySelector("body").classList.remove("no-scroll");
  }
}

window.addEventListener("DOMContentLoaded", function () {
  console.log("DOMContentLoaded: ");

  /* ========== handle wohu referral referral link click ========== */
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const referral_code = params.ref_id;
  if (referral_code) {
    console.log("This is a referral link! ", referral_code);

    openBox("referredBox");
  }
  /* show coupon if it is a successful referree*/
  const rewardRowTemplate = `
 <div class="rewardWrapper col-8">
   <div class="rewardText">   
     <span class="rewardNum"></span>
     <span class="rewardUnit"></span>
   </div>
   <div class="rewardDate"></div>
 </div>
 <div class="couponDes col-4">
   <div class="couponMsg"></div>
   <button class="couponCopy">Copy Coupon</button>
   <div class="rewardCode"></div>
 </div>
 `;
  /* end*/
  const closeBtns = document.querySelectorAll(".popupBox .close");
  closeBtns.forEach(closeBtn => {
    closeBtn.addEventListener("click", function () {
      const popupBox = this.closest(".popupBox");
      closeBox(popupBox.id);
    });
  });

  document
    .getElementById("referredDetailTrigger")
    .addEventListener("click", function () {
      const saveRefUrl =
        "https://8t4ri3zqd0.execute-api.us-east-1.amazonaws.com/dev/save_ref";
      // const saveRefUrl =
      //   "https://61b7e3f064e4a10017d18ce8.mockapi.io/dev/save_ref_success";
      // const saveRefUrl =
      //   "https://61b7e3f064e4a10017d18ce8.mockapi.io/dev/save_ref_fail";

      const friendEmail = document.getElementById("getReferredInput").value;
      this.disabled = true;
      axios
        .post(saveRefUrl, {
          email: friendEmail,
          referral_code: referral_code,
        })
        .then(response => {
          console.log(response.data);
          const item = response.data.coupon_code;

          if (item) {
            // GET coupoun code data and display it.
            const rewardText = item.action;
            const rewardNum = rewardText.substring(0, rewardText.length - 3);
            const rewardUnit = rewardText.substring(rewardText.length - 3);

            const status = item.status;
            const dateStringOptions = {
              year: "numeric",
              month: "short",
              day: "numeric",
            };
            const rewardDate = new Date(item.ends_at).toLocaleDateString(
              "en-US",
              dateStringOptions
            );
            const rewardCode = item.couponCode;

            const rewardRow = document.createElement("div");
            rewardRow.classList.add("couponTicket");
            rewardRow.classList.add("row");
            if (status === "expired") {
              rewardRow.classList.add("expiredCouponTicket");
            } else if (status === "used") {
              rewardRow.classList.add("usedCouponTicket");
            }
            rewardRow.innerHTML = rewardRowTemplate;

            rewardRow.querySelector(".rewardNum").textContent = rewardNum;
            rewardRow.querySelector(".rewardUnit").textContent =
              rewardUnit.toUpperCase();
            rewardRow.querySelector(".rewardDate").textContent =
              "Expires on " + rewardDate;
            if (status === "expired") {
              rewardRow.querySelector(".couponMsg").textContent =
                "This coupon has expired.";
            } else if (status === "used") {
              rewardRow.querySelector(".couponMsg").textContent =
                "This coupon has been used.";
            } else {
              rewardRow.querySelector(".couponMsg").textContent =
                "Start your Genki Forest journey now!";
            }
            rewardRow.querySelector(".rewardCode").textContent = rewardCode;
            rewardRow
              .querySelector(".couponCopy")
              .addEventListener("click", function () {
                navigator.clipboard.writeText(rewardCode);
                this.innerText = "COPIED";
              });
            const rewardsWrapper = document.getElementById(
              "rewardsWrapperFriend"
            );
            rewardsWrapper.appendChild(rewardRow);

            // toggle box
            closeBox("referredBox");
            openBox("referredDetailBox");
          } else {
            closeBox("referredBox");
            openBox("couponNotObtain");
          }
        })
        .catch(error => {
          console.log(error.response.data);
          closeBox("referredBox");

          openBox("couponNotObtain");
        });
    });

  /* ========== handle wohu referral referral link click ========== */

  // ================= mobile menu accordion =================

  const triggers = document.querySelectorAll(".accordion-trigger");
  triggers.forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      console.log("accordion clicked", this);
      this.closest(".accordion-section").classList.toggle("active");
    });
  });

  // ================= open announcement bar =================
  const hostname = window.location.hostname;
  function getCookie(c) {
    var d = document.cookie.split("; ");
    for (var b = 0; b < d.length; b++) {
      var a = d[b].split("=");
      if (a[0] == c) {
        return unescape(a[1]);
      }
    }
  }
  function setCookie(b, d, a, c) {
    var e = new Date();
    e.setTime(e.getTime() + c * 24 * 60 * 60 * 1000);
    document.cookie =
      b +
      "=" +
      escape(d) +
      ";expires=" +
      e.toGMTString() +
      "; domain=" +
      a +
      ";path=/";
  }

  const openTrigger = document.getElementById("ExpandTrigger");
  const expandableBar = document.getElementById("ExpandContainer");
  if (openTrigger) {
    openTrigger.addEventListener("click", openExpand);
  }
  const closeTrigger = document.getElementById("ExpandClose");
  if (closeTrigger) {
    closeTrigger.addEventListener("click", closeExpand);
  }

  function openExpand() {
    if (!expandableBar.classList.contains("open")) {
      expandableBar.classList.add("open");
      // localStorage.setItem("gk-dno-1", true);
      const expiry =
        document.querySelector(".banner-place-holder").dataset.autoopen || "7";
      console.log("expiry: ", expiry);
      setCookie("abar-opened", "1", hostname, parseInt(expiry));
    }
  }
  function closeExpand() {
    if (expandableBar.classList.contains("open")) {
      expandableBar.classList.remove("open");
    }
  }

  const hasImage = document.querySelector(".banner-place-holder").dataset
    .hasimage;
  console.log("hasImage: ", hasImage);
  const hasCookie = getCookie("abar-opened");
  if (hasImage === "true" && hasCookie !== "1") {
    console.log("should auto open");
    setTimeout(openExpand, 500);
  }
});
